import React, { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import InlineForm from 'components/forms/InlineForm';
import { saveData } from 'services/api/saveData';
import { FieldType } from 'types/FieldTypes';
import { FormButtonType } from 'types/ButtonTypes';
import { v4 as uuidv4 } from 'uuid';

const ResetPasswordForm: React.FC = () => {
    const viewKey = useMemo(() => uuidv4(), []);
    const history = useHistory();

    // Get the uid and token from the route params
    const { uid, token } = useParams<{ uid: string; token: string }>();

    const formHeader = 'account.reset_password_header_label'
    const formDescription = 'account.reset_password_header_description'

    const fields: FieldType[] = [
        {
            type: 'password',
            name: 'password',
            placeholder: 'account.reset_password_new_password_placeholder',
        },
        {
            type: 'password',
            name: 'password_confirm',
            placeholder: 'account.reset_password_confirm_password_placeholder',
        },
    ];

    const buttons: FormButtonType[] = [
        {
            label: 'account.reset_password_button_label',
            position: 'fullwidth',
            hierarchy: 'primary',
            onClick: 'handleSubmit',
            size: 'large',
            showLoader: true,
        },
    ];

    // Submits the new password together with the uid and token
    const handleResetPassword = async (data: Record<string, any>) => {

        // Check that both entered passwords match
        if (data.password !== data.password_confirm) {
            throw { response: { data: { password_confirm: 'account.reset_password_mismatch' } } };
        }

        // Save the new password on the server
        await saveData({
            apiUrl: 'post_resetpassword',
            method: 'post',
            data: { uid, token, password: data.password },
        });

        // Redirect to the login page after a successful reset
        history.push('/login?password_reset=success');
    };

    return (
        <InlineForm
            viewKey={viewKey}
            customApiFunction={handleResetPassword}
            formHeader={formHeader}
            formDescription={formDescription}
            fields={fields}
            buttons={buttons}
        />
    );
};

export default ResetPasswordForm;
